module.exports = __webpack_public_path__ + "af0572bf3100dc771139249de91fa2fb.png";